import { useMemo } from 'react'

export type UseTextStyleProps = {
  size:
    | 'heading1'
    | 'heading2'
    | 'heading3'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption1'
    | 'caption2'
    | 'base'
    | 'lg1'
    | 'lg2'
    | 'lg3'
    | 'lg4'
    | 'lg5'
    | 'lg6'
    | 'sm1'
    | 'sm2'
    | 'sm3'
    | 'sm4'
    | 'sm5'
  weight?: 'normal' | 'medium' | 'bold'
  underline?: boolean
}

export const useTextStyle = ({
  size,
  weight,
  underline,
}: UseTextStyleProps) => {
  const textStyle = useMemo(() => {
    switch (size) {
      case 'heading1':
        return 'sq-text-heading1'
      case 'heading2':
        return 'sq-text-heading2'
      case 'heading3':
        return 'sq-text-heading3'
      case 'subtitle1':
        return 'sq-text-subtitle-size-m'
      case 'subtitle2':
        return 'sq-text-subtitle-size-s'
      case 'body1':
        return 'sq-text-body-size-m'
      case 'body2':
        return 'sq-text-body-size-s'
      case 'caption1':
        return 'sq-text-caption-size-m'
      case 'caption2':
        return 'sq-text-caption-size-s'
      case 'base':
        return 'text-base'
      case 'lg1':
        return 'text-lg1'
      case 'lg2':
        return 'text-lg2'
      case 'lg3':
        return 'text-lg3'
      case 'lg4':
        return 'text-lg4'
      case 'lg5':
        return 'text-lg5'
      case 'lg6':
        return 'text-lg6'
      case 'sm1':
        return 'text-sm1'
      case 'sm2':
        return 'text-sm2'
      case 'sm3':
        return 'text-sm3'
      case 'sm4':
        return 'text-sm4'
      case 'sm5':
        return 'text-sm5'
      default:
        return ''
    }
  }, [size])

  const weightStyle = useMemo(() => {
    if (weight) return `font-${weight}`
    if (
      size === 'heading1' ||
      size === 'heading2' ||
      size === 'heading3' ||
      size === 'subtitle1' ||
      size === 'subtitle2'
    )
      return 'font-bold'

    return ''
  }, [size, weight])

  const underlineStyle = useMemo(() => {
    switch (underline) {
      case true:
        return 'sq-text-underline'
      default:
        return ''
    }
  }, [underline])

  return {
    textStyle,
    weightStyle,
    underlineStyle,
  }
}
